import * as constants from './constants'
import * as actions from './actions'
import * as localization from './localization'
import { createMedia } from '@artsy/fresnel'

export { actions }
export { localization }
export { constants }

export { default as reducer } from './reducer'

export * from './utility'
export * from './actionTypes'
export * from './models'
export * from './components/DataTable'

const AppMedia = createMedia({
    breakpoints: constants.mediaBreakpoints
});
const { Media, MediaContextProvider } = AppMedia;

export { Media, MediaContextProvider};  
export const mediaStyles = AppMedia.createMediaStyle();